import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Button from "../../atoms/button/button";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useScrollDetect from "../../../shared/hooks/useScrollDetect";
import { OptimizeImage } from "../../../shared/utils/stringUtilities";
import { getToken, getCmdFormData } from "../../../services/formServices";
import GlobalContext from "../../../contexts/globalContext";
import { navigate } from "gatsby";

// Styles //
import "./headboardCommunities.scss";

// Utils //
import { splitButtonText } from "../../../utils/helpers";

// Components
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ModalGuiaCdc from "../../molecules/modal-guia-cdc/modalGuiaCdc";
import Slider from "react-slick";

const CABECERA_50MAS_EMPRESAS_ID = "f88qjuaR54DVLwYYp31iL"
const CAVECERA_MIGRANTES_PERSONAS_ID = "5Ny3oD6r04RGrf6hyJa4UB"
const CABECERA_HOME_SERVICIOS_EMPRESARIALES = "1EmRtWZHZyQW2MJiwTvK72"

interface SlideContent {
   title: string;
   description: any;
   image: string;
   mainBtn: {
      text: string;
      href: string;
      onClick?: () => void;
   };
   secondaryBtn?: {
      text: string;
      href: string;
      onClick?: () => void;
   }
}
const HeadboardCommunities = (props: ReferenciaCabecera) => {
    const { window, document } = useBrowserMode();
    const { refElement } = useScrollDetect();
    const [doRedirect, setDoRedirect] = useState(false);
    const [showProtect, setShowProtect] = useState(true);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef<Slider | null>(null);
    const hasNextSlide = () => currentSlide < 2 - 1;
    const hasPrevSlide = () => currentSlide > 0;
    const hasAnchor:boolean = !!props.referenciaContenido;

    useEffect(() => {
        if (localStorage.getItem("hashSection")) {
            const section: any = document.getElementById(
                localStorage.getItem("hashSection")!
            );
            window.scrollTo({
                top: section?.offsetTop - 180,
                behavior: "smooth",
            });
        }
    }, []);

    const Context = useContext(GlobalContext);

    const closeModal = () => {
        document.body.style.overflow = "scroll";
        setIsOpenModal((setShow) => !setShow);
    };

    useEffect(() => {
        if (Context.gigyaContext.gigyaAccount && doRedirect) redirect();
    }, [Context.gigyaContext.gigyaAccount]);

    const handleIngresaAction = async () => {
        if (props.contentful_id !== "3sUfmqTvSosgQAeKjRQ3gC") {
            if (Context.gigyaContext.gigyaAccount) {
                redirect();
            } else {
                const checkGuideCdc = localStorage.getItem("guideCdc");
                if (checkGuideCdc !== "true") {
                    setIsOpenModal(true);
                } else {
                    Context.gigyaContext.loginComfamaId!();
                }
                setDoRedirect(true);
            }
        }
    };

    const redirect = async () => {
        setIsButtonDisabled(true);
        let responseData: any = await checkUserRegistered();
        if (
            responseData.data.answerData &&
            responseData.data.answerData.documentId
        ) {
            navigate(splitButtonText(props.redireccionBoton, 1));
        } else {
            navigate(splitButtonText(props.redireccionBoton, 0));
        }
        setIsButtonDisabled(false);
    };

    const checkUserRegistered = async () => {
        const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
        return getCmdFormData(
            Context!.gigyaContext!.gigyaAccount!.data.docNumber,
            token
        );
    };

    const handlePopup = () => {
        setShowProtect(false);
        sessionStorage.setItem("popup", "off");
    };

    const scrollToPlansAndRates = () => {
        const element = document.querySelector('.o-PlansAndRates');
        if (element) {
            //Esta varible y es para que el scroll tenga en cuenta una distancia de almenos 120px desde el top dela pantalla
            const y = element.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const CustomPrevArrow = (props: any) => {
        const { onClick } = props;
        const canGoPrev = hasPrevSlide();

        return (
            <button
                onClick={onClick}
                className={`slick-arrow slick-prev ${!canGoPrev ? 'disabled' : ''}`}
                style={{
                    backgroundColor: canGoPrev ? '#E6007E' : '#FCE3ED',
                    cursor: canGoPrev ? 'pointer' : 'default'
                }}
                type="button"
                aria-label="Anterior"
            />
        );
    };

    const CustomNextArrow = (props: any) => {
        const { onClick } = props;
        const canGoNext = hasNextSlide();

        return (
            <button
                onClick={onClick}
                className={`slick-arrow slick-next ${!canGoNext ? 'disabled' : ''}`}
                style={{
                    backgroundColor: canGoNext ? '#E6007E' : '#fce3ed',
                    cursor: canGoNext ? 'pointer' : 'default'
                }}
                type="button"
                aria-label="Siguiente"
            />
        );
    };

    const HomeSliderSettings = {
        dots: !hasAnchor,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: true,
        arrows: !hasAnchor,
        autoplaySpeed: 10000,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        beforeChange: (_: number, nextSlide: number) => {
            setCurrentSlide(nextSlide);
        }
    };

    let updatedMigaDePan = props.migaDePan.replace("Inicio /", "Inicio / Servicio de Empleo /");
    if (props.migaDePan.includes("Vacantes en Antioquia") || props.migaDePan === "Personas/Vacantes en Antioquia") {
        updatedMigaDePan = "Inicio / Servicio de Empleo / Personas / Vacantes en Antioquia";
      }
    const isPrimaryContentfulId = ["4WtTrLJzcuELFQgVzNdFhx", "5pxmnovYKyo3UQmInvrwXg", "1w9F4KG4EW3rpmSHVChCIv", "67i5NYw5rO5WHCDSbiLZcf", "5cNORerOFqo2i5pjeg59E6", "63kGbSmSurDyG8yoYH44Tj", CABECERA_50MAS_EMPRESAS_ID, CAVECERA_MIGRANTES_PERSONAS_ID].includes(props.contentful_id);
    const isSecondaryContentfulId = ["3Id3PeNxr1KuzWHrxo5mVM", "4hCujCbX6AWL2iYRyWJThG", "5yUTEbHCA0ewT5upGz7tGe", "4Oc8m1Gvsllw9bQ58DSMZJ", "4B4DMpekBs2t9HTwNFNA7X", "1arKHG7B0jlczz6lp4jzWX"].includes(props.contentful_id);
    const buttonIds = [
        "4hCujCbX6AWL2iYRyWJThG",
        "63kGbSmSurDyG8yoYH44Tj",
        "5cNORerOFqo2i5pjeg59E6",
        "PZIuvD8hplJ2VtIiYKJo3",
        "5pxmnovYKyo3UQmInvrwXg",
        "1w9F4KG4EW3rpmSHVChCIv",
        "4Oc8m1Gvsllw9bQ58DSMZJ",
        "4B4DMpekBs2t9HTwNFNA7X",
        "5yUTEbHCA0ewT5upGz7tGe",
        CABECERA_50MAS_EMPRESAS_ID,
        CAVECERA_MIGRANTES_PERSONAS_ID
    ];

    const bannerIsFor50MoreCompanies = props.contentful_id === CABECERA_50MAS_EMPRESAS_ID;

    const bottomBannerIsBigModal = ["4hCujCbX6AWL2iYRyWJThG", CABECERA_50MAS_EMPRESAS_ID ].includes(props.contentful_id);

    const basicSlideList = useMemo(() => {
      if (!props) return [];

      const mainSlide: SlideContent = {
         title: props.tituloPrincipal,
         description: props.descripcion,
         image: props.imagenHeader?.file?.url || "",
         mainBtn: {
            text: props.tituloBoton,
            href: props.redireccionBoton,
            onClick: undefined
         }
      }
      
      const extraSlides: SlideContent[] = props?.referenciaSlides?.map((content: any) => {
         const slide: SlideContent = {
            title: content?.tituloBanner || "",	
            description: content?.descripcion,
            image: content?.imagenPrincipal?.[0]?.file?.url || "",
            mainBtn: {
               text: content?.tituloBoton,
               href: content?.redireccionBoton,
               onClick: undefined
            }
         }
         return slide
      }) || []
      
      const slidesData: SlideContent[] = [
         mainSlide,
         ...extraSlides
      ]
      
      return slidesData
    }, [props])

    const currentSlideData = basicSlideList[currentSlide];

    const isOneSlide = basicSlideList.length === 1;
    
    return (
        <div className={`o-headboard-communities ${(props.contentful_id === "5WGTMXZOBDwPn19e43L9A9" || "3Id3PeNxr1KuzWHrxo5mVM" || "63kGbSmSurDyG8yoYH44Tj") ? "requirements" : ""} ${isOneSlide ? "single-slide" : ""} `} ref={refElement}>
            <div
                className={`o-headboard-communities__container ${isPrimaryContentfulId ? "o-headboardMpc" : isSecondaryContentfulId ? "o-headboardMpcInterna" : ""} ${bannerIsFor50MoreCompanies ? "o-50MoreCompanies" : ""} `}
            >
                <div className="container">
                    {typeof window !== "undefined" && window.innerWidth >= 768 && (
                        <Breadcrumb content={updatedMigaDePan} />
                    )}
                    {props.imagenLogo && !sessionStorage.getItem("popup") && (
                        <div
                            className={`banner-headboard-text__logo ${bottomBannerIsBigModal ? "banner-headboard-text__logo--big-modal" : ""}`}
                            style={{
                                display: `${showProtect ? "flex" : "none"}`,
                            }}
                        >
                            <span onClick={handlePopup}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="17.536"
                                    height="17.536"
                                    viewBox="0 0 17.536 17.536"
                                >
                                    <g
                                        id="x"
                                        transform="translate(1.768 1.768)"
                                    >
                                        <line
                                            id="Línea_80"
                                            data-name="Línea 80"
                                            x1="14"
                                            y2="14"
                                            transform="translate(0 0)"
                                            fill="none"
                                            stroke="#303030"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2.5"
                                        />
                                        <line
                                            id="Línea_81"
                                            data-name="Línea 81"
                                            x2="14"
                                            y2="14"
                                            transform="translate(0 0)"
                                            fill="none"
                                            stroke="#303030"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2.5"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <div className="headboard-communities-imageFixed">
                                <img
                                    src={props.imagenLogo.file.url}
                                    alt={
                                        props.imagenLogo.description || "Imagen"
                                    }
                                />
                            </div>
                            <div className="headboard-communities-text__header__title">
                                <h3>{props.tituloBannerAuxiliar}</h3>
                                <div
                                    className={`headboard-communities-text__description ${props.contentful_id ===
                                        "4WtTrLJzcuELFQgVzNdFhx"
                                        ? "o-headboardMpcText"
                                        : props.contentful_id === "3sUfmqTvSosgQAeKjRQ3gC"
                                            ? "o-aprendizajeBannerText"
                                            : ""
                                        }`}
                                >
                                    {props.descripcionAuxiliarBanner}
                                </div>
                            </div>
                            <div className={props.contentful_id === "3sUfmqTvSosgQAeKjRQ3gC"
                                ? "headboard-communities-text__descriptionMobileAprendizaje"
                                : "headboard-communities-text__descriptionMobile"}>
                                {props.descripcionAuxiliarBannerMobile}
                            </div>
                            <div className="headboard-communities-text__buttons__itemBanner">
                                {props.contentful_id === "3sUfmqTvSosgQAeKjRQ3gC" ? (
                                    <Button
                                        type="link"
                                        text={props.tituloSpan}
                                        classname="a-button__magentaBannerAprendizaje"
                                        isDisabled={false}
                                        href={props.tituloBotonBanner}
                                    />
                                ) : props.contentful_id === "5yUTEbHCA0ewT5upGz7tGe" || props.contentful_id === "4Oc8m1Gvsllw9bQ58DSMZJ" || props.contentful_id === "4hCujCbX6AWL2iYRyWJThG" || props.contentful_id === CABECERA_50MAS_EMPRESAS_ID ? (
                                    <Button
                                        type="link"
                                        text={props.tituloSegundoBoton}
                                        classname="a-button__magentaBannerAprendizaje"
                                        isDisabled={false}
                                        href={props.redireccionSegundoBoton}
                                    />
                                ) : (
                                    <Button
                                        onClickAction={handleIngresaAction}
                                        type="button"
                                        text={props.tituloSpan}
                                        classname="a-button__magentaBanner gtm_unete_a_la_comunidad_banner_flotante"
                                        isDisabled={isButtonDisabled}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    <div className="o-headboard-communities__inner">
                        <div className={`headboard-communities-text`}>
                            <h1>{currentSlideData.title}</h1>
                            <div className="headboard-communities-imageMobile">
                                {props.imagenHeader && (
                                    <img
                                        src={OptimizeImage(
                                            props.imagenHeader.file.url,
                                            props.imagenHeader.file.contentType,
                                            props.imagenHeader.file.details
                                                .image.width
                                        )}
                                        alt={
                                            props.imagenHeader.title ||
                                            "imagen cabecera sala de prensa"
                                        }
                                        loading="lazy"
                                    />
                                )}
                            </div>
                            {currentSlideData.description &&
                                documentToReactComponents(
                                    currentSlideData.description.json
                                )}
                            {props.contentful_id === CABECERA_HOME_SERVICIOS_EMPRESARIALES && (
                                <div className={`headboard-communities-text__buttons`}>
                                    <div className="headboard-communities-text__buttons__item">
                                        <Button
                                            onClickAction={scrollToPlansAndRates}
                                            type="button"
                                            text={props.tituloBoton}
                                            classname={`a-button__magenta gtm_ingresa_a_la_comunidad_banner_home`}
                                            isDisabled={false}
                                        />
                                    </div>
                                </div>
                            )}
                            {props.contentful_id ===
                                "6Cbz13TpFr7UxQFe8gVaj3" && (
                                    <div className={`headboard-communities-text__buttons`}>
                                        <div className="headboard-communities-text__buttons__item">
                                            <Button
                                                onClickAction={handleIngresaAction}
                                                type="button"
                                                text={props.tituloBoton}
                                                classname={`a-button__magenta gtm_ingresa_a_la_comunidad_banner_home`}
                                                isDisabled={isButtonDisabled}
                                            />
                                        </div>
                                    </div>
                                )}
                            {buttonIds.includes(props.contentful_id) && (
                                <div className=" ">
                                    <div>
                                        <Button
                                            type="link"
                                            text={currentSlideData.mainBtn.text}
                                            classname={`a-button primary  gtm_postularme_banner_interna_requisitos_subsidio_desempleo`}
                                            isDisabled={false}
                                            href={currentSlideData.mainBtn.href}
                                        />
                                    </div>
                                </div>
                            )}
                            {props.contentful_id ===
                                "5WGTMXZOBDwPn19e43L9A9" && (
                                    <div className={` ${props.contentful_id === "5WGTMXZOBDwPn19e43L9A9" ? "requirements" : ""} `}>
                                        <div>
                                            <Button
                                                type="link"
                                                text={props.tituloBoton}
                                                classname={`a-button__magenta gtm_postularme_banner_interna_requisitos_subsidio_desempleo`}
                                                isDisabled={false}
                                                href={props.location.href.replace("requisitos-postulacion/", props.redireccionBoton)}
                                                self
                                            />
                                        </div>
                                    </div>
                                )}
                            {(props.contentful_id === "4WtTrLJzcuELFQgVzNdFhx" || props.contentful_id === "3sUfmqTvSosgQAeKjRQ3gC") && (
                                <div className="headboard-communities-text__buttons">
                                    <div className="headboard-communities-text__buttons__itemMpc gtmPostularmeSubsidioMPC">
                                        {props.tituloBoton && (
                                            <>
                                                <Button
                                                    onClickAction={handleIngresaAction}
                                                    type="link"
                                                    text={splitButtonText(props.tituloBoton, 0)}
                                                    classname={`a-button primary`}
                                                    isDisabled={false}
                                                    href={splitButtonText(props.redireccionBoton, 0)}
                                                />
                                                <Button
                                                    onClickAction={handleIngresaAction}
                                                    type="link"
                                                    text={splitButtonText(props.tituloBoton, 1)}
                                                    classname={`a-button__magenta gtm_conocer_requisitos_banner_subsidio_desempleo`}
                                                    isDisabled={false}
                                                    href={splitButtonText(props.redireccionBoton, 1)}
                                                />
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                            {hasAnchor && 
                                <ul className="headboard-communities-text__anchor">{props.referenciaContenido.referenciaContenido.map((anchor)=>
                                    <a href={`#${anchor.fields.tituloBanner}`}>
                                        <img src={anchor.fields.imagenPrincipal[0].fields.file.url}/>
                                        <span>{anchor.fields.tituloBanner}</span>
                                    </a>
                                )}</ul>
                            }
                        </div>
                        <div className="headboard-communities-image">
                            {props.imagenHeader && (

                                <Slider {...HomeSliderSettings} ref={sliderRef}>
                                    {basicSlideList.map((slide, index) => (
                                       <div key={`slide-img-${index}-${slide.image}`} className="headboard-communities-image__item">
                                          <img  src={slide.image} alt={`Slide ${index}`} />
                                       </div>
                                    ))}
                                </Slider>

                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isOpenModal && (
                <ModalGuiaCdc showModal={isOpenModal} onClose={closeModal} />
            )}
        </div>
    );
};

export default HeadboardCommunities;
